const entityTypes = new Set(['entity', 'company', 'corporate', 'trust', 'foundation']);
export const isEntityNameType = type => entityTypes.has(String(type || '').trim().toLowerCase());

// A name-format check only; this does not establish identity or assess risk.
export function needsFullName(subject) {
  if (isEntityNameType(subject?.subjectType || subject?.meta?.subjectType)) return false;
  const parts = String(subject?.name || '').trim().split(/\s+/u).filter(part => /\p{L}/u.test(part));
  return parts.length < 2;
}

export function hasIncompleteScreeningName(form) {
  const customer = form?.customer || {};
  if (!isEntityNameType(customer.type)) return needsFullName(customer);
  const ownership = form?.ownership || {};
  const people = [
    ...(ownership.shareholders || ownership.directShareholders || []).map(row => ({
      ...row, subjectType: row.holderType || row.partyType || row.entityType || row.type,
    })),
    ...(ownership.ubos || []),
    ...(ownership.signatories || []),
  ];
  const trust = ownership.legalArrangements?.arrangements?.find(arr =>
    String(arr.arrangementType || arr.type).toLowerCase() === 'trust' && arr.source === 'account_holder');
  for (const party of trust?.parties || []) {
    if (!['settlor', 'trustee', 'beneficiary'].includes(String(party.role).toLowerCase())) continue;
    if (/^class\b|\bunnamed\b/i.test(party.name || '')) continue;
    people.push({ ...party, subjectType: party.trusteeKind || party.subjectType });
  }
  return people.some(person => String(person.name || '').trim() && needsFullName(person));
}

export function editScreeningSubjectName(subject) {
  const roles = subject.roles || [];
  const id = roles.includes('Client') ? 'kyc-sec-customer'
    : roles.includes('Authorised signatory') ? 'kyc-sec-signatories' : 'kyc-sec-ownership';
  const section = document.getElementById(id);
  if (!section) return;
  const normalize = value => String(value || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
  const target = [...section.querySelectorAll('input, button[aria-label="Edit full name"]')]
    .find(el => !el.disabled && normalize(el.value || el.textContent) === normalize(subject.name));
  (target || section).scrollIntoView?.({ behavior: 'smooth', block: 'center' });
  if (target?.tagName === 'BUTTON') target.click();
  else if (target) target.focus({ preventScroll: true });
}
